"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("uiUtils", function ($parse) {
  return {
    parseConstantExpr: function parseConstantExpr(context, name, expression, fallback) {
      var parseFn;
      if (angular.isDefined(expression)) {
        parseFn = $parse(expression);
        if (!parseFn.constant) {
          throw 'Expected constant expression for `' + name + '`, but saw ' + expression;
        }
        return parseFn(context);
      }
      return fallback;
    },
    fakeNgModel: function fakeNgModel() {
      return {
        $fake: true,
        $setTouched: angular.noop,
        $setViewValue: function $setViewValue(value) {
          this.$viewValue = value;
          this.$render(value);
          this.$viewChangeListeners.forEach(function (cb) {
            cb();
          });
        },
        $isEmpty: function $isEmpty(value) {
          return ('' + value).length === 0;
        },
        $parsers: [],
        $formatters: [],
        $viewChangeListeners: [],
        $render: angular.noop
      };
    },
    isAnchor: function isAnchor(attr) {
      return angular.isDefined(attr.href) || angular.isDefined(attr.ngHref) || angular.isDefined(attr.ngLink);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/buttons/uiUtils.js
// module id = 2927
// module chunks = 13